import React from "react";
import LoungeSearchActionGroup from "container/searchForGuest/LoungeSearchActionGroup";
import LoungeSearchListPanel from "container/searchForGuest/LoungeSearchListPanel";
import LoginRecommendationView from "presentational/lounge/LoginRecommendationView";
import { withStore } from "store/storeHandler";
import PropTypes from "prop-types";

RootSearchForGuest.propTypes = {
  onLoginRecommendationBtnClick: PropTypes.func.isRequired
};

function RootSearchForGuest(props) {
  const {
    onLoginRecommendationBtnClick,
    outfitList,
    isLoading,
    isEnd,
    SearchForLoungeActions,
    AppErrorActions
  } = props;

  const getNewSearchList = async query => {
    try {
      await SearchForLoungeActions.getListForLounge(query);
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  return (
    <div>
      <LoungeSearchActionGroup getNewList={getNewSearchList} />
      <LoungeSearchListPanel
        outfitList={outfitList}
        isLoading={isLoading}
        isEnd={isEnd}
      />
      <LoginRecommendationView
        bottomView
        onLoginRecommendationBtnClick={onLoginRecommendationBtnClick(
          "loungePage-lower"
        )}
      />
    </div>
  );
}

export default withStore({
  stateMap: { searchForLounge: ["outfitList", "isEnd", "isLoading"] },
  dispatchMap: ["searchForLounge", "appError"]
})(RootSearchForGuest);
